import React, { useEffect, useState } from "react"

import Container from "semantic-ui-react/dist/commonjs/elements/Container/Container"
import ActionBar from "../components/core/ActionBar"
import Filter from "../components/core/Filter/Filter"
import VerificarAntecedentesListView from "../components/CheckProfile/Nacionals/VerificarAntecedentesListView"

import Pagination from "../components/core/Pagination"

import { useTranslation } from "react-i18next"

import API from "../common/API"
import { Card } from "react-bootstrap"
import AdminVerificarAntecedentesFilterFields from "../components/Admin/AdminVerificarAntecedentes.filterFields"

function IdentitiesPage() {
  // PROPERTIES


  const [page, setPage] = useState(0)
  const [quantity, setQuantity] = useState(20)
  const [totalPages, setTotalPages] = useState(1)

  const [consentUploaded, setConsentUploaded] = useState<boolean>(false)
  const [records, setRecords] = useState<any>([])
  const [filterValues, setFilterValues] = useState<any>({})

  const [filterFields, setFilterFields] = useState(AdminVerificarAntecedentesFilterFields
  )
  const getFilterValues = obj => {
    setFilterValues(obj)
  }

  const { t } = useTranslation("global")

  const [isLoading, setIsLoading] = useState(false)


  // METHODS

  const onPageChanged = (obj: number) => {
    setPage(obj)
  }
  const handleFileChange = async e => {
    const file = e.target.files[0]
    if (file) {
      setConsentUploaded(true)
    }
  }
  const bindDataRemote = async () => {
    try {
      setIsLoading(true)

      if (Object.keys(filterValues).length === 0) {
        return
      }


      let query = "external=false";

      Object.keys(filterValues).forEach(key => {
        query += "&" + key + "=" + filterValues[key]
      })

      query += "&page=" + page + "&quantity=" + quantity
      setIsLoading(true)
      let routePath = "busqueda/nacionales" + "?" + query
      let request = await API.getAction(routePath)
      console.log(request)
      if (request.data.status === "ok") {
        setRecords(request.data.response)
        setTotalPages(request.data.quantityOfPages)
        // setPage(request.data.page)
      }

    } catch (e) {
      console.error(e)
    } finally {
      setIsLoading(false)
    }
  }
  // EVENTS
  useEffect(() => {
    bindDataRemote()
  }, [page])


  useEffect(() => {
    if (Object.keys(filterValues).length === 0) {
      setPage(0)
      setRecords([])
      return
    }
    if (filterValues) {
      setPage(0)
      setTimeout(() => {
        bindDataRemote()
      }, 500)
    }
  }, [filterValues])

  return (
    <Container>
      <ActionBar
        title={t("Identidades")}
        actions={
          <>
            <div className="ms-2 btn-group">

            </div>
          </>
        }
      ></ActionBar>

      <div className="my-4">


        <Filter
          // toggleFilter={toggleFilter}
          title={t("Verificar Por:")}
          fields={filterFields}
          setFilterFields={getFilterValues}
          filterAction={() => {
            console.log("filter")

            bindDataRemote()
          }}
        />

      </div>
      {isLoading && (
        <div className="text-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}

      <VerificarAntecedentesListView
        records={records}
        admin={true}
        backgroundCheck={false}
        isLoading={isLoading}
      />


      <Card className="mb-4">
        <Card.Body className="p-0 pt-2">
          <Pagination
            totalPages={totalPages}
            currentPage={page}
            onPageChanged={onPageChanged}
          />
        </Card.Body>
      </Card>
    </Container>
  )
}

export default IdentitiesPage
